(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('projectCategoriesService', projectCategoriesService);

	projectCategoriesService.$inject = ['$http', 'URLS'];

	function projectCategoriesService($http, URLS) {
		return {
			deleteCategory: deleteCategory,
			replaceCategory: replaceCategory,
			saveProjectCategory: saveProjectCategory
		};

		function deleteCategory(categoryNdx, siteId) {
			var projectCategoryCrudUrl = URLS.host + String.format(URLS.projectCategoryCrud, siteId || globalConfig.factory.id);

			return $http.delete(projectCategoryCrudUrl + '/' + categoryNdx)
				.then(deleteProjectCategorySuccess, handleError);

			function deleteProjectCategorySuccess(response) {
				return response;
			}
		}

		function replaceCategory(categoryNdx, newCategoryNdx, siteId) {
			var projectCategoryCrudUrl = URLS.host + String.format(URLS.projectCategoryCrud, siteId || globalConfig.factory.id);

			return $http.put(projectCategoryCrudUrl + '/' + categoryNdx + '/' + newCategoryNdx)
				.then(replaceProjectCategorySuccess, handleError);

			function replaceProjectCategorySuccess(response) {
				return response;
			}
		}

		function saveProjectCategory(category, siteId) {
			var projectCategoryCrudUrl = URLS.host + String.format(URLS.projectCategoryCrud, siteId || category.factoryNdx || globalConfig.factory.id);

			return $http.put(projectCategoryCrudUrl, category)
				.then(saveProjectCategorySuccess, handleError);

			function saveProjectCategorySuccess(response) {
				return response;
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412 || error.status === 409) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
